import React from 'react';
import EnvironmentContext from './EnvironmentContext';

const EnvironmentConsumer = EnvironmentContext.Consumer;

export default WrappedComponent => props => (
  <EnvironmentConsumer>
    {environmentVars => <WrappedComponent environmentVars={environmentVars} {...props} />}
  </EnvironmentConsumer>
);
